<template>
  <div class="flex-list ">
    <h4 class="layoutheader">Includes:</h4>
    <div>
      <div role="group" aria-label="Basic group">
        <ul>
          <li v-for="item in whatAreIncluded" :key="item">
            <label for="item">{{ item }} </label>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['configuration'],
  data() {
    return {
      whatAreIncluded: []
    };
  },
  watch: {
    configuration() {
      this.whatAreIncluded = this.configuration.whatisincluded;
    }
  }
};
</script>
<style scoped>
ul {
  list-style-type: none;
}

.layoutheader {
  margin: 1.5rem;
}
</style>
